import { Reveal, SectionHeader } from "@/components/site/Reveal";
import { ABOUT_VALUE_ICONS } from "@/data/content";
import { useLanguage } from "@/i18n/LanguageContext";

export const About = () => {
    const { t } = useLanguage();

    return (
        <section id="about" className="relative py-24 md:py-32" data-testid="about-section">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="max-w-3xl mx-auto">
                    <div>
                        <SectionHeader
                            number={t.about.number}
                            label={t.about.label}
                            title={t.about.title}
                        />
                        <Reveal delay={0.2}>
                            <p className="text-base md:text-lg text-zinc-400 leading-relaxed font-light mb-10 -mt-8">
                                {t.about.paragraph}
                            </p>
                        </Reveal>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            {t.about.values.map((value, i) => {
                                const Icon = ABOUT_VALUE_ICONS[i];
                                return (
                                    <Reveal key={value.title} delay={0.25 + i * 0.08}>
                                        <div
                                            className="group glass-card glass-card-hover rounded-xl p-5 transition-transform duration-300 hover:-translate-y-1"
                                            data-testid={`about-value-${i}`}
                                        >
                                            <Icon className="h-6 w-6 text-cyan-400 mb-3 transition-transform duration-300 group-hover:scale-110" strokeWidth={1.5} />
                                            <h3 className="font-display font-bold text-white mb-1">{value.title}</h3>
                                            <p className="text-sm text-zinc-400 font-light">{value.description}</p>
                                        </div>
                                    </Reveal>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
